

















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import { ListProps } from '@/constants/components/list'

@Component({
  components: { SingleText }
})
export default class List extends Vue {
  // リスト設定値
  @Prop({ default: [] })
  private records!: Array<ListProps>;
  // 追加付与するclass
  @Prop({ default: '' })
  private addClass?: string;

  /**
   * 親コンポーネントに選択した行を通知する
   * @module clickOpratipon
   * @return ListProps - 押下行の情報
   */
  @Emit('clickOpratipon')
  public clickOpratipon(clickRecord: ListProps): ListProps {
    return clickRecord;
  }

}
